import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24bf198a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "fas fa-fw fa-times"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Gutschein ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Beim Bestellen einer neuen Kurs­karte können prinzip­bedingt nur Rabatt-Gutscheine ver­wen­det werden. Wenn du einen Gut­schein für eine Kurs­karte ein­lösen möchtest, kannst du das nach Anmeldung in deinem Benutzer­profil tun. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Du hast einen Rabatt-Gutschein ein­gegeben. Er kann nur ein­gelöst werden, während du eine neue Kurs­karte bestellst. Bitte such dir eine ent­sprech­ende Kurs­karte aus und löse den Gut­schein im Be­stell­prozess ein. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Es ist ein Fehler aufgetreten. Bitte versuche es noch einmal oder melde dich bei deiner Gebietsleiterin. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Es ist ein Fehler aufgetreten. Bitte versuche es noch einmal oder melde dich bei deiner Gebietsleiterin. ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Gutscheincode ist ungültig oder kann nicht mehr eingelöst werden. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        ref: "voucherCode",
        type: "text",
        class: _normalizeClass(["form-control voucher-input", {'is-invalid': _ctx.isInvalid}]),
        placeholder: "Gutscheincode",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.voucherCodeInputValue) = $event)),
        disabled: _ctx.locked,
        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"])),
        maxlength: "20"
      }, null, 42, _hoisted_2), [
        [
          _vModelText,
          _ctx.voucherCodeInputValue,
          void 0,
          { trim: true }
        ]
      ]),
      _createElementVNode("a", {
        ref: "submit",
        class: "btn btn-primary",
        href: "#",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        (_ctx.locked)
          ? (_openBlock(), _createElementBlock("i", _hoisted_3))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fas fa-fw", {'fa-tag': !_ctx.loading, 'fa-spinner fa-spin': _ctx.loading}])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.buttonLabel), 1)
            ], 64))
      ], 512)
    ]),
    (_ctx.state && !(_ctx.isValid && _ctx.context === 'free') /* free gets handled in parent component */)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          class: "mt-3",
          type: _ctx.stateAlertType
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(["fas fa-fw me-1", {'fa-check': _ctx.isValid, 'fa-exclamation-triangle': _ctx.isInvalid}])
            }, null, 2),
            (_ctx.isValid)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4,
                  _createElementVNode("b", null, _toDisplayString(_ctx.voucherCodeInputValue), 1),
                  _createTextVNode(" aktiviert" + _toDisplayString(_ctx.activeVoucherInfo ? ' (' + _ctx.activeVoucherInfo + ')' : '') + ". ", 1)
                ], 64))
              : (_ctx.state === 'contextMismatch')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.context === 'checkout')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_5
                        ], 64))
                      : (_ctx.context === 'free')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_6
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _hoisted_7
                          ], 64))
                  ], 64))
                : (_ctx.state === 'error')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_8
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _hoisted_9
                    ], 64))
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true)
  ]))
}